[
    {
        "type": "Input",
        "data": {
            "name": "username",
            "label": "شماره موبایل",
            "props": {
                "autofocus": true,
                "autocomplete": "username",
                "size": "xl",
                "type": "tel",
                "inputmode": "numeric",
                "pattern": "[0-9]*",
                "style": "direction: ltr"
            }
        }
    }
]
